/**
 * Real, tiny files for the source viewers — PDF, Word and an image.
 *
 * The viewers are only honestly storyable with bytes their real renderers can
 * open: `react-pdf` parses the PDF, `docx-preview` unzips and lays out the
 * Word file, and the browser decodes the PNG. Text formats get away with a
 * string (`sourceFileHandler`); these cannot.
 *
 * Generated once with Python's standard library — the PDF with a correct
 * xref table, the DOCX as a minimal OOXML zip — and inlined as base64 so no
 * binary blob is committed. Each is under 1KB.
 *
 * - `mockPdfDataUri`: TWO pages ("Page one: light reactions", "Page two: the
 *   Calvin cycle"), so a page indicator has somewhere to move.
 * - `mockDocxDataUri`: a bold "Photosynthesis notes" line and a paragraph,
 *   "Chlorophyll absorbs red and blue light."
 * - `mockPngDataUri`: a 64x48 green square.
 */
export const mockPdfDataUri =
  'data:application/pdf;base64,' +
  'JVBERi0xLjQKMSAwIG9iago8PCAvVHlwZSAvQ2F0YWxvZyAvUGFnZXMgMiAwIFIgPj4KZW5kb2Jq' +
  'CjIgMCBvYmoKPDwgL1R5cGUgL1BhZ2VzIC9LaWRzIFszIDAgUiA1IDAgUl0gL0NvdW50IDIgPj4K' +
  'ZW5kb2JqCjMgMCBvYmoKPDwgL1R5cGUgL1BhZ2UgL1BhcmVudCAyIDAgUiAvTWVkaWFCb3ggWzAg' +
  'MCAzMDAgMjAwXSAvQ29udGVudHMgNCAwIFIgL1Jlc291cmNlcyA8PCAvRm9udCA8PCAvRjEgNyAw' +
  'IFIgPj4gPj4gPj4KZW5kb2JqCjQgMCBvYmoKPDwgL0xlbmd0aCA1NiA+PgpzdHJlYW0KQlQgL0Yx' +
  'IDE4IFRmIDI0IDEwMCBUZCAoUGFnZSBvbmU6IGxpZ2h0IHJlYWN0aW9ucykgVGogRVQKZW5kc3Ry' +
  'ZWFtCmVuZG9iago1IDAgb2JqCjw8IC9UeXBlIC9QYWdlIC9QYXJlbnQgMiAwIFIgL01lZGlhQm94' +
  'IFswIDAgMzAwIDIwMF0gL0NvbnRlbnRzIDYgMCBSIC9SZXNvdXJjZXMgPDwgL0ZvbnQgPDwgL0Yx' +
  'IDcgMCBSID4+ID4+ID4+CmVuZG9iago2IDAgb2JqCjw8IC9MZW5ndGggNTcgPj4Kc3RyZWFtCkJU' +
  'IC9GMSAxOCBUZiAyNCAxMDAgVGQgKFBhZ2UgdHdvOiB0aGUgQ2FsdmluIGN5Y2xlKSBUaiBFVApl' +
  'bmRzdHJlYW0KZW5kb2JqCjcgMCBvYmoKPDwgL1R5cGUgL0ZvbnQgL1N1YnR5cGUgL1R5cGUxIC9C' +
  'YXNlRm9udCAvSGVsdmV0aWNhID4+CmVuZG9iagp4cmVmCjAgOAowMDAwMDAwMDAwIDY1NTM1IGYg' +
  'CjAwMDAwMDAwMDkgMDAwMDAgbiAKMDAwMDAwMDA1OCAwMDAwMCBuIAowMDAwMDAwMTIxIDAwMDAw' +
  'IG4gCjAwMDAwMDAyNDcgMDAwMDAgbiAKMDAwMDAwMDM1MyAwMDAwMCBuIAowMDAwMDAwNDc5IDAw' +
  'MDAwIG4gCjAwMDAwMDA1ODYgMDAwMDAgbiAKdHJhaWxlcgo8PCAvU2l6ZSA4IC9Sb290IDEgMCBS' +
  'ID4+CnN0YXJ0eHJlZgo2NTYKJSVFT0YK';

export const mockDocxDataUri =
  'data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64,' +
  'UEsDBBQAAAAIAFOuOl15bjPX6AAAAK0BAAATAAAAW0NvbnRlbnRfVHlwZXNdLnhtbH1QyU7DMBD9' +
  'FWuuKHHggBCK0wPLETiUDxjZk8SqN3nc0v49Tlt6QIXjzFv1+tXeO7GjzDYGBbdtB4KCjsaGScHn' +
  '+rV5AMEFg0EXAyk4EMNq6NeHRCyqNrCCuZT0KCXrmTxyGxOFiowxeyz1zJNMqDc4kbzrunupYygU' +
  'SlMWDxj6Zxpx64p42df3qUcmxyCeTsQlSwGm5KzGUnG5C+ZXSnNOaKvyyOHZJr6pBJBXExbk74Cz' +
  '7r0Ok60h8YG5vKGvLPkVs5Em6q2vyvZ/mys94zhaTRf94pZy1MRcF/euvSAebfjpL49zD99QSwME' +
  'FAAAAAgAU646XZv9N+qtAAAAKQEAAAsAAABfcmVscy8ucmVsc43POw7CMAwG4KtE3mlaBoRQ0y4I' +
  'qSsqB7ASN61oHkrCo7cnAwNFDIy2f3+W6/ZpZnanECdnBVRFCYysdGqyWsClP232wGJCq3B2lgQs' +
  'FKFt6jPNmPJKHCcfWTZsFDCm5A+cRzmSwVg4TzZPBhcMplwGzT3KK2ri27Lc8fBpwNpknRIQOlUB' +
  '6xdP/9huGCZJRydvhmz6ceIrkWUMmpKAhwuKq3e7yCzwpuarF5sXUEsDBBQAAAAIAFOuOl1vRRI2' +
  'zgAAADoBAAARAAAAd29yZC9kb2N1bWVudC54bWxtj8FqxDAMRH/F+N447WEpIfEeFnreQ/sBTqzG' +
  'BlsylrbZ/H2TlLYUeplh0PDQ9Od7TuoDKkfCQT82rVaAE/mI86DfXl8enrVicehdIoRBr8D6bPul' +
  '8zTdMqCoDYDcLYMOIqUzhqcA2XFDBXC7vVPNTrZYZ7NQ9aXSBMwbPyfz1LYnk11EvSNH8uvuZZd6' +
  'yPWw0dje/CSx10BCvKIE4MgKSYD3gnzVDi1/SWIvIVGlEtaUlBuZ6siqglfbNjWmG6gU5yDNPxzz' +
  '/Zr5nW0/AVBLAQIUAxQAAAAIAFOuOl15bjPX6AAAAK0BAAATAAAAAAAAAAAAAACAAQAAAABbQ29u' +
  'dGVudF9UeXBlc10ueG1sUEsBAhQDFAAAAAgAU646XZv9N+qtAAAAKQEAAAsAAAAAAAAAAAAAAIAB' +
  'GQEAAF9yZWxzLy5yZWxzUEsBAhQDFAAAAAgAU646XW9FEjbOAAAAOgEAABEAAAAAAAAAAAAAAIAB' +
  '7wEAAHdvcmQvZG9jdW1lbnQueG1sUEsFBgAAAAADAAMAuQAAAOwCAAAAAA==';

export const mockPngDataUri =
  'data:image/png;base64,' +
  'iVBORw0KGgoAAAANSUhEUgAAAEAAAAAwCAIAAAAuKetIAAAAZElEQVR4nO3PUQkAIBTAwJfIQKYz' +
  'qiH8OITBAtxmnf11wwUNaEEDWtCAFjSgBQ1oQQNa0IAWNKAFDWhBA1rQgBY0oAUNaEEDWtCAFjSg' +
  'BQ1oQQNa0IAWNKAFDWhBA1rQgBY8dgHKp+DEr6LHUwAAAABJRU5ErkJggg==';

/**
 * A PDF with one line of text per page, built at runtime — for documents too
 * long to inline, such as the 30-page one the viewer's lazy page mounting needs
 * (`mockLongPdfDataUri`). A correct xref table, so pdf.js opens it without its
 * repair path. Text is ASCII only; it is written into a literal string.
 */
export function pdfDataUri(pageTexts: string[]): string {
  const n = pageTexts.length;
  const objects: string[] = [];
  // 1 catalog, 2 pages, 3 font, then (page, content) pairs from 4.
  const kids = pageTexts.map((_, i) => `${4 + i * 2} 0 R`).join(' ');
  objects.push('<< /Type /Catalog /Pages 2 0 R >>');
  objects.push(`<< /Type /Pages /Kids [${kids}] /Count ${n} >>`);
  objects.push('<< /Type /Font /Subtype /Type1 /BaseFont /Helvetica >>');
  pageTexts.forEach((text, i) => {
    const safe = text.replace(/[\\()]/g, c => `\\${c}`);
    const stream = `BT /F1 24 Tf 72 720 Td (${safe}) Tj ET`;
    objects.push(
      `<< /Type /Page /Parent 2 0 R /MediaBox [0 0 612 792] ` +
        `/Resources << /Font << /F1 3 0 R >> >> /Contents ${5 + i * 2} 0 R >>`
    );
    objects.push(
      `<< /Length ${stream.length} >>\nstream\n${stream}\nendstream`
    );
  });

  let body = '%PDF-1.4\n';
  const offsets = objects.map((obj, i) => {
    const at = body.length;
    body += `${i + 1} 0 obj\n${obj}\nendobj\n`;
    return at;
  });
  const xrefAt = body.length;
  body +=
    `xref\n0 ${objects.length + 1}\n0000000000 65535 f \n` +
    offsets.map(o => `${String(o).padStart(10, '0')} 00000 n \n`).join('') +
    `trailer\n<< /Size ${objects.length + 1} /Root 1 0 R >>\n` +
    `startxref\n${xrefAt}\n%%EOF\n`;
  return `data:application/pdf;base64,${btoa(body)}`;
}

/** 30 pages, "Page 1 of 30" … "Page 30 of 30". */
export const mockLongPdfDataUri = pdfDataUri(
  Array.from({ length: 30 }, (_, i) => `Page ${i + 1} of 30`)
);
